/* eslint-disable no-param-reassign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, TabPane, TabContent,
  NavLink, NavItem, Nav, Button, Label, InputGroup,
} from 'reactstrap';

import moment from 'moment';
import classnames from 'classnames';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Field, FormikConsumer, ErrorMessage,
} from 'formik';

import BaseGrid from '../Common/BaseGrid';
import * as url from '../../helpers/url_helper';

function TrucksFieldset(props) {
  const { arrayHelpers } = props;

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [signal, setSignal] = useState(1);
  const [activeTab, setActiveTab] = useState('3');

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const handleAddTruck = () => {
    arrayHelpers.unshift({
      id: null,
      reference: '',
      cost: '',
      pallet_count: '0',
    });
  };

  return (
    <FormikConsumer>
      {({
        touched, errors, values,
      }) => (
        <div>
          <Nav tabs className="nav-tabs-custom justify-content-end">
            <NavItem>
              <NavLink
                style={{ cursor: 'pointer' }}
                className={classnames({
                  active: activeTab === '1',
                })}
                onClick={() => {
                  toggle('1');
                }}
              >
                {props.t('Associated')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: 'pointer' }}
                className={classnames({
                  active: activeTab === '2',
                })}
                onClick={() => {
                  toggle('2');
                }}
              >
                {props.t('Search')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: 'pointer' }}
                className={classnames({
                  active: activeTab === '3',
                })}
                onClick={() => {
                  toggle('3');
                }}
              >
                {props.t('Create')}
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent
            activeTab={activeTab}
            className="text-muted"
          >
            <TabPane tabId="1">
              <Row>
                <Col sm="12" className="mt-3">
                  <BaseGrid
                    url={url.GET_TRUCKS}
                    shouldPaginate={false}
                    shouldUpdate={signal}
                    list={values.shipments.map((x) => (x.id))}
                    config={
                    {
                      columns: {
                        id: { label: 'ID', sort: true },
                        reference: { label: 'Reference', sort: true },
                        expected_at: {
                          label: 'Expected',
                          date: {
                            format: (date) => (moment(date).fromNow()),
                            timezone: process.env.LOCAL_TZ,
                          },
                        },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'remove',
                              icon: 'mdi mdi-close-thick',
                              class: 'btn btn btn-sm btn-soft-dark',
                              alt: props.t('Remove'),
                              click: (ent) => {
                                for (let i = 0; i < values.shipments.length; i += 1) {
                                  if (values.shipments[i].id === ent.id) {
                                    arrayHelpers.remove(i);
                                    setSignal(signal + 1);
                                  }
                                }
                              },
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 3,
                      },
                    }
                    }
                  />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="2">
              <Row>
                <Col sm="12">
                  <BaseGrid
                    url={url.GET_TRUCKS}
                    hasSearch
                    shouldPaginate={false}
                    skipSort
                    config={
                    {
                      columns: {
                        id: { label: 'ID', sort: true },
                        reference: { label: 'Reference', sort: true },
                        created_at: {
                          label: 'Created',
                          date: {
                            format: (date) => (moment(date).fromNow()),
                            timezone: process.env.LOCAL_TZ,
                          },
                        },
                        expected_at: {
                          label: 'Expected',
                          date: {
                            format: (date) => (moment(date).fromNow()),
                            timezone: 'UTC',
                          },
                        },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'select',
                              icon: 'mdi mdi-check-bold',
                              class: 'btn btn-sm btn-soft-dark',
                              alt: props.t('Select'),
                              click: (ent) => {
                                // Add if not already
                                if (values.shipments.map((x) => (x.id)).indexOf(ent.id) === -1) {
                                  arrayHelpers.unshift(ent);
                                  setSignal(signal + 1);
                                  setActiveTab('1');
                                } else {
                                  toastr.warning(props.t('Shipment already added to order'));
                                }
                              },
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 3,
                      },
                    }
                    }
                  />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="3">
              <Row>
                <Col sm="12">
                  <div className="mt-3">
                    <Button className="btn btn-sm btn-info" onClick={handleAddTruck}>
                      <span className="mdi mdi-plus-thick" />
                    </Button>
                  </div>

                  {values.shipments.map((x, index) => (
                    <div key={`new_ship_${index}`}>
                      {x.id === null && (
                        <div className="vstack gap-3 mt-3 mb-4">
                          {index > 0 && (<hr />)}
                          <div className="row">
                            <Label
                              for={`truck_reference_${index}`}
                              className="col-md-3 col-form-label"
                            >
                              {props.t('Reference')}
                            </Label>
                            <Col md={4}>
                              <InputGroup>
                                <Field
                                  type="text"
                                  className="form-control"
                                  id={`truck_reference_${index}`}
                                  name={`shipments[${index}].reference`}
                                />
                                <Button
                                  type="button"
                                  onClick={() => arrayHelpers.remove(index)}
                                  color="danger"
                                  className="btn-soft-danger"
                                >
                                  <span className="mdi mdi-close-thick" />
                                </Button>
                              </InputGroup>
                              <ErrorMessage
                                name={`shipments[${index}].reference`}
                                component="div"
                                className="text-danger pt-1"
                              />
                            </Col>
                          </div>

                          <div className="row">
                            <Label
                              for={`truck_cost_${index}`}
                              className="col-sm-3 col-form-label"
                            >
                              {props.t('Cost')}
                            </Label>
                            <Col sm={4}>
                              <div className="input-group">
                                <div className="input-group-prepend">
                                  <span className="input-group-text">$</span>
                                </div>
                                <Field
                                  type="text"
                                  className="form-control"
                                  id={`truck_cost_${index}`}
                                  name={`shipments[${index}].cost`}
                                />
                              </div>
                              <ErrorMessage
                                name={`shipments[${index}].cost`}
                                component="div"
                                className="text-danger pt-1"
                              />
                            </Col>
                          </div>

                          <div className="row">
                            <Label
                              for={`truck_pc_${index}`}
                              className="col-sm-3 col-form-label"
                            >
                              {props.t('Pallet Count')}
                            </Label>
                            <Col sm={3}>
                              <Field
                                type="text"
                                className="form-control"
                                id={`truck_pc_${index}`}
                                name={`shipments[${index}].pallet_count`}
                              />
                              <ErrorMessage
                                name={`shipments[${index}].pallet_count`}
                                component="div"
                                className="text-danger pt-1"
                              />
                            </Col>
                          </div>

                          <div className="row">
                            <Label
                              for={`truck_ed_${index}`}
                              className="col-md-3 col-form-label"
                            >
                              {props.t('Expected Date')}
                            </Label>
                            <Col md={3}>
                              <Field
                                type="date"
                                className="form-control"
                                id={`truck_ed_${index}`}
                                name={`shipments[${index}].expected_at`}
                              />
                              <ErrorMessage
                                name={`shipments[${index}].expected_at`}
                                component="div"
                                className="text-danger pt-1"
                              />
                            </Col>
                          </div>

                          <div className="row">
                            <Label
                              for={`truck_origin_${index}`}
                              className="col-sm-3 col-form-label"
                            >
                              {props.t('Origin')}
                            </Label>
                            <Col sm={6}>
                              <Field
                                as="textarea"
                                className="form-control"
                                id={`truck_origin_${index}`}
                                name={`shipments[${index}].origin`}
                              />
                              <ErrorMessage
                                name={`shipments[${index}].origin`}
                                component="div"
                                className="text-danger pt-1"
                              />
                            </Col>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </div>
      )}
    </FormikConsumer>
  );
}

TrucksFieldset.defaultProps = {

};

TrucksFieldset.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  arrayHelpers: PropTypes.object.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(TrucksFieldset));
